(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('RealtyTypeDetailController', RealtyTypeDetailController);

    RealtyTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RealtyType'];

    function RealtyTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, RealtyType) {
        var vm = this;

        vm.realtyType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:realtyTypeUpdate', function(event, result) {
            vm.realtyType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
